module.exports = __webpack_public_path__ + "media/images/frontend/instagram-7de4b656af3a864f6fbacb14738ead31.png";